export default __webpack_public_path__ + "static/media/resume icon.8fcd1ffd.svg";